export const nlBE = {
  app: {
    categories: {
      convectors: 'Convectoren',
      decorative: 'Designradiatoren',
      electric: 'Elektrische radiatoren',
      panels: 'Paneelradiatoren',
      towel: 'Badkamerradiatoren',
    },
    categoryLabel: 'Categorie ',
    categoryPlaceholder: 'Selecteer een categorie',
    errorCategories: 'Kon categorieën niet laden.',
    errorPanels: 'Kon radiatoren niet laden.',
    loadingCategories: 'Categorieën laden...',
    loadingPanels: 'Radiatoren laden...',
    panelLabel: 'Radiatoren',
    panelPlaceholder: 'Selecteer een radiator',
    titles: {
      convectors: 'Calculator voor convectoren',
      decorative: 'Calculator voor designradiatoren',
      electric: 'Calculator voor elektrische radiatoren',
      panels: 'Calculator voor paneelradiatoren',
      towel: 'Calculator voor badkamerradiatoren',
    },
  },
  calc: {
    actionButton: 'Toon berekende producten',
    boost: 'Boost-modus',
    calculateRequiredButton: 'Bereken benodigd vermogen',
    calculating: 'Berekenen...',
    comfort: 'Comfort-modus',
    downloadLabel: 'Download gegevens ({count})',
    emptyResults: 'Nog geen resultaten.',
    errorMatch: 'Kon resultaten niet berekenen.',
    errorTypes: 'Kon radiatortypes niet laden.',
    flowTemp: 'Aanvoer C°',
    height: 'Hoogte',
    length: 'Lengte',
    loadingTypes: 'Types laden...',
    modeLabel: 'Modus',
    modes: {
      cooling: 'Koeling',
      heating: 'Verwarming',
    },
    radiatorType: 'Radiatortype',
    requiredWatts: 'Benodigd vermogen (W)',
    resultsMessage: '{count} producten beschikbaar voor geselecteerde opties.',
    returnTemp: 'Retour C°',
    roomTemp: 'Kamertemperatuur C°',
    selectAllLabel: 'Selecteer alle producten',
    selectItemLabel: 'Selecteer product om te downloaden',
    selectPanel: 'Selecteer een radiator om te berekenen.',
    standby: 'Standby-modus',
    tableHeaders: {
      calculatedWattage: 'Vermogen',
      co2Equivalent: 'CO2-equivalent per kg materiaal',
      depth: 'Diepte [mm]',
      description: 'Productomschrijving',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Hoogte [mm]',
      itemId: 'Productcode',
      length: 'Lengte [mm]',
      waterContent: 'Waterinhoud',
      weight: 'Gewicht',
    },
    title: 'Berekeningen',
    tolerance: 'Tolerantie',
    typeCooling: 'Koeling',
    typeGroupLabel: 'Type',
    typeHeating: 'Verwarming',
  },
  existingRadiator: {
    description:
      'Deze calculator is alleen bedoeld ter informatie. Raadpleeg altijd een professionele installateur voor de exacte berekening voordat u de radiator aanschaft.',
    height: 'Radiatorhoogte',
    length: 'Radiatorlengte',
    resultLabelTemplate: 'Benodigde warmteafgifte, berekend bij {temp} systeemtemperatuur',
    select: 'Selecteren',
    temperature: 'Systeemtemperatuur',
    type: 'Radiatortype',
  },
  matrixCalc: {
    axisHeight: 'Hoogte (mm)',
    axisLength: 'Lengte (mm)',
    axisType: 'Type',
    calculateButton: 'Calculate',
    displayLabel: 'Weergave',
    exportExcel: 'Exporteren naar Excel',
    exportPdf: 'Exporteren naar PDF',
    print: 'Afdrukken',
    hideOutOfRange: 'Items buiten bereik verbergen',
    showAll: 'Alles tonen',
    loading: 'Loading...',
    lockHeight: 'Hoogte',
    lockLabel: 'Afmeting vastzetten',
    lockLength: 'Lengte',
    lockType: 'Type',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Berekenen',
    clearButton: 'Alles wissen',
    fields: {
      ceilingHeight: 'Plafondhoogte',
      doorInsulation: 'Deurisolatie',
      floorInsulation: 'Vloerisolatie',
      glazingArea: 'Totale oppervlakte beglazing',
      glazingMode: 'Totale oppervlakte beglazing',
      glazingQuality: 'Kwaliteit van beglazing',
      length: 'Lengte',
      outerWalls: 'Buitenmuren',
      projectedDesignTemp: 'Ontwerpbuitentemperatuur',
      roofInsulation: 'Dakisolatie',
      roomArea: 'Oppervlakte',
      roomFloor: 'Verdieping',
      roomInsulation: 'Isolatieniveau',
      roomPreset: 'Kamertype',
      roomTemperature: 'Ruimtetemperatuur',
      roomType: 'Kamertype',
      uncertaintyFactor: 'Onzekerheidsfactor',
      ventilation: 'Ventilatieniveau',
      wallInsulation: 'Muurisolatie',
      width: 'Breedte',
      windConditions: 'Windomstandigheden',
      windowInsulation: 'Raamisolatie',
    },
    intro:
      'Bereken het warmteverlies in de ruimte om het juiste product te selecteren uit het Radson radiatoren-assortiment.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Meer dan 20%',
        low: 'Minder dan 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Meer dan 20%',
        below_10: 'Minder dan of gelijk aan 10%',
        from_10_to_20: 'Van 10% tot 20%',
        no_windows: 'Geen ramen',
      },
      insulationValue: {
        good: 'Goed',
        medium: 'Gemiddeld',
        poor: 'Slecht',
        very_good: 'Zeer goed',
      },
      qualityValue: {
        modern_excellent: 'Modern, uitstekende energie-efficiëntie',
        modern_good: 'Modern, goede energie-efficiëntie',
        old_poor: 'Oud, zeer slechte energie-efficiëntie',
        traditional_medium: 'Traditioneel, gemiddelde energie-efficiëntie',
      },
      roomValue: {
        bathroom_24: 'Badkamer (24°C)',
        bedroom_20: 'Keuken, Bureau (20°C)',
        garage_12: 'Garage (12°C)',
        livingroom_22: 'Leefruimte (22°C)',
        storage_16: 'Opslagruimte, Hal (16°C)',
        extra_1: 'Slaapkamer (18°C)',
      },
      select: 'Selecteren',
      storeyValue: {
        ground_multi: 'Gelijkvloers met plafond erboven',
        ground_single: 'Gelijkvloers met dak erboven',
        interim: 'Verdieping met plafond erboven',
        top_multi: 'Verdieping met dak erboven',
      },
      temp: {
        climate_zone_1: '-5 °C',
        climate_zone_2: '-6 °C',
        climate_zone_3: '-7 °C',
        climate_zone_4: '-8 °C',
        climate_zone_5: '-9 °C',
        climate_zone_6: '-10 °C',
        climate_zone_7: '-11 °C',
        climate_zone_8: '-12 °C',
      },
      windInfluence: {
        normal: 'Normaal',
        strong: 'Sterk',
        weak: 'Zwak',
      },
    },
    roomPresets: {
      bathroom: 'Badkamer',
      bedroom: 'Slaapkamer',
      garage: 'Garage',
      kitchen: 'Keuken',
      living: 'Woonkamer',
      storage: 'Opslag',
    },
    sections: {
      dimensions: 'Afmetingen van de ruimte',
      insulation: 'Isolatie',
      placement: 'Plaatsing',
      result: 'Resultaat',
      temps: 'Temperaturen',
      ventilation: 'Ventilatie',
    },
    title: 'Warmteverliesberekening ruimte',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Gebruiken',
  },
  slider: {
    from: 'Van',
    to: 'Tot',
    value: 'Waarde',
  },
}
